import { useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { persistCities } from "../../app/features/citiesSlice";
import { citiesService } from "../../services/cityService";
import { useQuery } from "@tanstack/react-query";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "./Home.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BreadcrumbsNavigation from "../../components/Breadcrumbs/BreadcrumbsNavigation";
import SelectFiltration from "../../components/SelectFiltration/SelectFiltration";
import WelcomeImageLg from "../../assets/images/welcome_image_lg.webp";
import WelcomeImageSm from "../../assets/images/welcome_image_sm.webp";
import WelcomeImageMd from "../../assets/images/welcome_image_md.webp";
import MapCustomIcon from "../../assets/images/map-custom-icon.svg";
import L from "leaflet";
import MapPopup from "../../components/MapPopup/MapPopup";
import { calculateGridElements } from "../../utils/helpers";
import { filterByValues } from "../../utils/constants";
import GridCards from "../../components/Cards/CityCards/CityCards";


const markerCustomIcon = L.icon({
  iconUrl: MapCustomIcon,
  iconSize: [30, 30],
  iconAnchor: [12.5, 35],
  popupAnchor: [3, -40],
});

const Home = () => {

  const checkImageResolution = (width) => {
    if (width <= 480) {
      return WelcomeImageSm;
    } 
    if (width > 480 && width <= 1100) {
      return WelcomeImageMd;
    }
    if (width > 1100) {
      return WelcomeImageLg;
    }
  }

  const dispatch = useAppDispatch();
  const [sortOrder, setSortOrder] = useState("mostRecent");
  const [loadIndex, setLoadIndex] = useState(1);
  const [welcomeImage, setWelcomeImage] = useState(() => {
    const windowWidth = window.innerWidth;
    return checkImageResolution(windowWidth);
  });

  const pageSize = calculateGridElements();

  const {
    isLoading,
    data: citiesData,
    isSuccess,
  } = useQuery({
    queryKey: ["cities"],
    queryFn: () => citiesService.getAllCities(),
  });

  

  dispatch(persistCities(citiesData?.data?.cities));

  const { t } = useTranslation();

  const [mapCenter, setMapCenter] = useState([
    50.33882269482202, 16.313009014215144,
  ]);

  const filterBy = (value) => {
    setSortOrder(value);
  };

  const handleWelcomeImage = (e) => {
    setWelcomeImage(() => {
      const windowWidth = e.target.innerWidth;
      return checkImageResolution(windowWidth);
  });
  };

  useEffect(() => {
    window.addEventListener("resize", handleWelcomeImage);

    return () => {
      window.removeEventListener("resize", handleWelcomeImage);
      //cleanup listener
    };
  }, []);

  return (
    <div className="homepage">
      <div className="home_page_heading_wrapper">
        <div className="titles_wrapper_main">
          <div className="title_small">Navigate And Explore</div>
          <div className="title_large">
            CITIES WHERE{" "}
            <span className="title_word_background_line_wrapper">
              {" "}
              <span className="title_word_background_line"></span>YOU{" "}
            </span>{" "}
            CAN MAKE A DIFFERENCE.
          </div>
        </div>
        <div className="welcome_img_wrapper">
          <img className="welcome_image" src={welcomeImage} alt="Welcome" />
          <div className="welcome_text_wrapper">
            <div className="welcome_text__par_1">{t('welcomeTo')}</div>
            <div className="welcome_text__par_2">{t('worldOfCotown')}</div>
            <div className="welcome_text__v_line"></div>
            <div className="welcome_text__par_3">{t('exploreTheCitiesText')}</div>
          </div>
        </div>
        
      </div>

      <MapContainer
        className="full-height-map"
        center={mapCenter}
        zoom={4}
        scrollWheelZoom={true}
        minZoom={2}
        // ref={setMap}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {citiesData?.data?.cities?.map((ct) => {
          return (
            <Marker
              icon={markerCustomIcon}
              key={ct?.id}
              position={[ct?.langth, ct?.latitued]}
            >
              <Link to={`/${ct.name}`} state={ct}>
                <MapPopup cityName={ct.name} pinCount={ct.pinCount}></MapPopup>
              </Link>
            </Marker>
          );
        })}
      </MapContainer>

      <div className="page_content">
        <div className="curr_cities_title_wrapper">
          <p className="curr_cities_title">{t("currentCities")}</p>
          <p className="curr_cities_subtitle">
            Discover the cities ready for transformation!
          </p>
        </div>

        <div className="breadcrumbs_filter">
          <div className="breadcrumbs_container">
            <BreadcrumbsNavigation
              locations={[
                { link: "/", name: "Cotown Map", iconName: "cotownMapIcon" },
              ]}
            ></BreadcrumbsNavigation>
          </div>
          <div className="select_filter_home">
            <SelectFiltration
              values={filterByValues}
              filterBy={(e) => filterBy(e)}
            ></SelectFiltration>
          </div>
        </div>

        <div className="cities">
          <GridCards
            cities={citiesData?.data?.cities}
            sortOrder={sortOrder}
            loadIndex={loadIndex}
            pageSize={pageSize}
          ></GridCards>
        </div>

        <div className="load_more_wrapper">
          <button
            style={{
              display:
                citiesData?.data?.cities?.length >= loadIndex * pageSize
                  ? "inline"
                  : "none",
            }}
            onClick={() => setLoadIndex((number) => number + 1)}
            className="load_more_btn"
          >
            Load more
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
